import React from "react";
import "../../assets/css/Text.css";

type ReadOnlyFieldProps = {
  label: string;
  value?: string | null;
  className?: string;
  prefix?: string;
};

export default function ReadOnlyField ({
  label,
  value,
  className = "",
  prefix = "",
}: ReadOnlyFieldProps): React.ReactElement {
  return (
    <div className={`read-only-field shrink-0 ${className}`}>
      <label>{label}</label>
      {prefix}{value || "-"}
    </div>
  );
}
